// extracted by mini-css-extract-plugin
export default {"overlay":"bC-z","bodyOpen":"cC-z","content":"dC-z","header":"eC-z","close":"fC-z","closeNoHeading":"gC-z"};